import { BasicTeaser } from 'component/teaser';
import { component, demoFile } from 'system/demo';

demoFile('component/teaser');

component('BasicTeaser', BasicTeaser);
